import { useState, useCallback } from 'react';

export const useNodeResizing = () => {
  const [resizing, setResizing] = useState(false);
  const onResizeStart = useCallback(() => {
    setResizing(true);
  }, [setResizing]);

  const onResize = useCallback(() => {
    setResizing(true);
  }, [setResizing]);

  const onResizeEnd = useCallback(() => {
    setResizing(false);
  }, []);

  return {
    resizing,
    onResizeStart,
    onResize,
    onResizeEnd,
  };
};
